import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'menuFilter',
    standalone: false
})
export class MenuFilterPipe implements PipeTransform {
  transform(input: any[], toMatch: string): any[] {
    console.log('pp:', toMatch);
    if (toMatch) {
      if (input && input.length) {
        input = input.map(item => {
          item.menuDefinition = item.menuDefinition.filter(child => child['label'].toLowerCase().indexOf(toMatch.toLowerCase()) > -1);
          // return item.menuDefinition.filter( child => ((child['label'].toLowerCase()).indexOf(toMatch.toLowerCase()) > -1) );
          return item;
        });
      }
    }

    return input;
  }
}
